<template>
  <b-form-group
    :label="`${label + asterisk}`"
    :label-for="`input-${name}-${_uid}`"
    :label-class="{
      'label-light-grey': focused || isOpen,
      'is-invalid': currentState == false,
    }"
  >
    <b-form-input
      :id="`input-${name}-${_uid}`"
      :type="type"
      :class="{ open: focused || isOpen }"
      :state="currentState"
      :required="required"
      v-model.lazy="value"
      v-mask="mask"
      v-bind="$attrs"
      @focus="focused = true"
      @blur="focused = false"
      :maxlength="maxlength"
    ></b-form-input>
  </b-form-group>
</template>
<script>
export default {
  name: "InputComponent",
  props: ["name", "type", "label", "required", "mask", "check", "max", "maxlength"],
  data() {
    return {
      value: this.$attrs.value,
      focused: false,
    };
  },
  watch: {
    focused: function() {
      return this.focused;
    },
    value: function(newValue) {
      if (this.max && parseInt(newValue) > parseInt(this.max)) {
        this.value = this.max + "%";
      }

      this.$parent.$v[this.name].$touch();
      this.$emit("input", this.value);
    },
  },
  computed: {
    currentState: function() {
      if (!this.$parent.$v[this.name].$dirty) {
        return null;
      }

      if (this.$parent.$v[this.name].$error && this.required) {
        return false;
      }

      if (!this.$parent.$v[this.name].$error && this.check) {
        return true;
      }

      return null;
    },
    asterisk: function() {
      return this.required ? "*" : "";
    },
    isOpen: function() {
      return this.value;
    },
  },
  inheritAttrs: false,
};
</script>
<style lang="scss"></style>
